import { toastr } from 'react-redux-toastr';
import { AUTH_ACTION_TYPES } from './actionTypes';
import { authApi } from './api';

export const requestOtp = ({ phone, lang = 'ru' }) => {
    return async (dispatch) => {
        dispatch({ type: AUTH_ACTION_TYPES.OTP_REQUEST });

        try {
            const result = await authApi.requestOtp({ phone, lang });

            dispatch({
                type: AUTH_ACTION_TYPES.OTP_SUCCESS,
                payload: {
                    phone,
                    otpSession: result.data,
                },
            });

            return { success: true, data: result.data };
        } catch (error) {
            console.error('OTP request error:', error);

            dispatch({
                type: AUTH_ACTION_TYPES.OTP_FAILURE,
                payload: { error: error.message },
            });

            toastr.error('Ошибка', error.message);
            return { success: false, error: error.message };
        }
    };
};

export const confirmOtp = ({ phone, idSession, otpCode, lang = 'ru' }) => {
    return async (dispatch) => {
        dispatch({ type: AUTH_ACTION_TYPES.LOGIN_OTP_REQUEST });

        try {
            const result = await authApi.confirmOtp({ phone, idSession, otpCode, lang });

            const token = result.token;

            dispatch({
                type: AUTH_ACTION_TYPES.LOGIN_OTP_SUCCESS,
                payload: {
                    token,
                    user: {
                        user_name: result.user_name,
                        display_name: result.user_display_name,
                        device_id: result.device_id,
                    },
                },
            });

            toastr.success('Добро пожаловать, ' + (result.user_display_name || '') + '!');

            dispatch(fetchUserData(token));

            return { success: true, token };
        } catch (error) {
            console.error('OTP confirm error:', error);

            dispatch({
                type: AUTH_ACTION_TYPES.LOGIN_OTP_FAILURE,
                payload: { error: error.message },
            });

            toastr.error('Ошибка', error.message);
            return { success: false, error: error.message };
        }
    };
};

export const signup = ({ phone, email, password, displayName, firstName, lastName, lang = 'ru' }) => {
    return async (dispatch) => {
        dispatch({ type: AUTH_ACTION_TYPES.SIGNUP_REQUEST });

        try {
            const result = await authApi.signup({ phone, email, password, displayName, firstName, lastName, lang });

            const token = result.token;

            if (token) {
                dispatch({
                    type: AUTH_ACTION_TYPES.SIGNUP_SUCCESS,
                    payload: {
                        token,
                        user: {
                            user_name: result.user_name,
                            display_name: result.user_display_name,
                        },
                    },
                });

                toastr.success('Добро пожаловать, ' + (result.user_display_name || '') + '!');

                dispatch(fetchUserData(token));

                return { success: true, token };
            }

            dispatch({
                type: AUTH_ACTION_TYPES.SIGNUP_SUCCESS,
                payload: { token: null, user: null },
            });

            return { success: true, data: result };
        } catch (error) {
            console.error('Signup error:', error);

            dispatch({
                type: AUTH_ACTION_TYPES.SIGNUP_FAILURE,
                payload: { error: error.message },
            });

            toastr.error('Ошибка регистрации', error.message);
            return { success: false, error: error.message };
        }
    };
};

export const fetchUserData = (token) => {
    return async (dispatch, getState) => {
        const authToken = token || getState().auth?.token;

        if (!authToken) {
            return;
        }

        dispatch({ type: AUTH_ACTION_TYPES.FETCH_USER_REQUEST });

        try {
            const userData = await authApi.fetchUser(authToken);

            dispatch({
                type: AUTH_ACTION_TYPES.FETCH_USER_SUCCESS,
                payload: { user: userData },
            });

            return userData;
        } catch (error) {
            console.error('Fetch user error:', error);

            dispatch({
                type: AUTH_ACTION_TYPES.FETCH_USER_FAILURE,
                payload: { error: error.message },
            });
        }
    };
};

export const logout = () => {
    return (dispatch) => {
        dispatch({ type: AUTH_ACTION_TYPES.LOGOUT });
        toastr.info('', 'Вы вышли из системы');
    };
};

export const clearAuthError = () => ({
    type: AUTH_ACTION_TYPES.CLEAR_ERROR,
});
